import React, { useEffect, useState } from "react";
import { api, mediaUrl } from "../lib/api";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api
      .get("/site/blog")
      .then((r) => setPosts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section id="blog" data-testid="blog-section" className="py-20 sm:py-28">
      <div className="container-prose">
        <div className="flex flex-col sm:flex-row justify-between items-end gap-6 mb-12">
          <div>
            <p className="overline">13 — Insights</p>
            <h2 className="h2-display mt-4 text-4xl sm:text-5xl text-ink">
              Notes from the <span className="italic text-forest">profession</span>.
            </h2>
          </div>
          <p className="body-prose text-ink/70 max-w-md">
            Essays, frameworks-in-progress and reflections — published as Karamjeet writes.
          </p>
        </div>

        {posts.length === 0 ? (
          <div className="border border-dashed border-ink/25 p-12 text-center body-prose text-ink/60">
            New essays coming soon. In the meantime, find Karamjeet's published chapters via TESOL Press.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/15">
            {posts.slice(0, 6).map((p, i) => (
              <Link
                to={`/blog/${p.slug}`}
                key={p.id}
                data-testid={`blog-card-${i}`}
                className="group bg-ivory p-7 sm:p-8 hover:bg-ink hover:text-ivory transition-colors"
              >
                {p.cover_image && (
                  <div className="aspect-[16/9] mb-5 overflow-hidden bg-ink/5">
                    <img
                      src={mediaUrl(p.cover_image)}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                    />
                  </div>
                )}
                <p className="overline group-hover:text-ivory/70">
                  {new Date(p.created_at).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </p>
                <h3
                  className="mt-3 text-2xl sm:text-3xl"
                  style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
                >
                  {p.title}
                </h3>
                {p.excerpt && (
                  <p className="mt-3 body-prose text-[15px] line-clamp-3 opacity-80">
                    {p.excerpt}
                  </p>
                )}
                <div className="mt-6 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] font-medium">
                  Read essay
                  <ArrowUpRight size={14} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
